var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fieldset",
    [
      _c("checkbox-field", {
        staticClass: "_mt-0",
        attrs: {
          disabled: _vm.readOnly,
          type: "radio",
          "checked-value": _vm.customerEntityTypes.individual,
          "custom-label-text":
            _vm.Resources.Checkout.CustomerEntityTypeIndividualLabel,
          "data-qa": "customer-entity-type:Individual",
        },
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      }),
      _vm._v(" "),
      _c("checkbox-field", {
        attrs: {
          disabled: _vm.readOnly,
          type: "radio",
          "checked-value": _vm.customerEntityTypes.business,
          "custom-label-text":
            _vm.Resources.Checkout.CustomerEntityTypeBusinessLabel,
          "data-qa": "customer-entity-type:Business",
        },
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }